export enum GenderEnum {
  Male = 'Male',
  Female = 'Female',
}

export enum RoleEnum {
  ADMIN = 'ADMIN',
  MEMBER = 'MEMBER',
}
